import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';
import { ModalService } from '@spartacus/storefront';
import { PageLabelClassDirective } from '../../directives';

@Component({
  selector: 'sd-modal',
  templateUrl: './modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [PageLabelClassDirective],
  standalone: true,
})
export class ModalComponent {
  constructor(private modalService: ModalService) {}

  closeModal(reason?: any): void {
    this.modalService.closeActiveModal(reason);
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(): void {
    this.modalService.closeActiveModal();
  }
}
